const initialTripReport = {
    tripReportPermissions:{},
    tripReportLists: [],
    tripReportCount: [],
    tripApprovalLists: [],
    tripApprovalCount: [],
    tripApprovalPermissions: {},
    tripApprovalReportLists: [],
    tripApprovalReportCount: [],
    tripApprovalReportPermissions: {},
    changedtripReportStatus: [],
    loadingTripReport: false,
    errorsTripReport: {}
}

const  tripReportReducer = (state = initialTripReport, action) => {
    switch (action.type) {
        case "GET_TRIP_REPORT_PENDING":
        case "GET_TRIP_REPORT_APPROVAL_PENDING":
        case "APPROVE_TRIP_REPORT_PENDING":
        case "GET_TRIP_APPROVAL_PENDING":
        case "GET_TRIP_APPROVAL_REPORT_PENDING":
            return { ...state, loadingTripReport: true };

        case "GET_TRIP_REPORT_FULFILLED":
        case "GET_TRIP_REPORT_APPROVAL_FULFILLED":
            return {
                ...state,
                loadingTripReport: false,
                tripReportLists: action.payload,
                tripReportCount: action.count,
                tripReportPermissions:action.permissions,
            };

        case "GET_TRIP_REPORT_REJECTED":
        case "GET_TRIP_REPORT_APPROVAL_REJECTED":
            return {
                ...state,
                loadingTripReport: false,
                errorsTripReport: action.payload
            };

        case "APPROVE_TRIP_REPORT_FULFILLED":
            return {
                ...state,
                loadingTripReport: false,
                changedtripReportStatus: action.payload,
            };

        case "APPROVE_TRIP_REPORT_REJECTED":
            return {
                ...state,
                loadingTripReport: false,
                errorsTripReport: action.payload
            };

        case "GET_TRIP_APPROVAL_FULFILLED":
            return {
                ...state,
                loadingTripReport: false,
                tripApprovalLists: action.payload,
                tripApprovalCount: action.count,
                tripApprovalPermissions: action.permissions,
            };

        case "GET_TRIP_APPROVAL_REJECTED":
            return {
                ...state,
                loadingTripReport: false,
                errorsTripReport: action.payload
            };

        case "GET_TRIP_APPROVAL_REPORT_FULFILLED":
            return {
                ...state,
                loadingTripReport: false,
                tripApprovalReportLists: action.payload,
                tripApprovalReportCount: action.count,
                tripApprovalReportPermissions: action.permissions,
            };

        case "GET_TRIP_APPROVAL_REPORT_REJECTED":
            return {
                ...state,
                loadingTripReport: false,
                errorsTripReport: action.payload
            };

        case "RESET_APPROVE_TRIP_REPORT_STATUS":
            return {
                ...state,
                changedtripReportStatus: [],
                errorsTripReport: {}
            };

        default:
            return state;
    }
}

export default tripReportReducer;